var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThermometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 6.25C13.9404 6.25 14.5 5.69036 14.5 5C14.5 4.30964 13.9404 3.75 13.25 3.75C12.5596 3.75 12 4.30964 12 5C12 5.69036 12.5596 6.25 13.25 6.25Z",
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.18909V3C5.5 2.46957 5.71071 1.96086 6.08579 1.58579C6.46086 1.21071 6.96957 1 7.5 1C8.03043 1 8.53914 1.21071 8.91421 1.58579C9.28929 1.96086 9.5 2.46957 9.5 3V9.18909L9.50049 9.18846C10.0338 9.60499 10.4238 10.1776 10.6161 10.8264C10.8083 11.4752 10.7933 12.1678 10.573 12.8077C10.3528 13.4475 9.93828 14.0026 9.38739 14.3956C8.8365 14.7886 8.17669 14.9998 7.5 14.9998C6.82331 14.9998 6.1635 14.7886 5.61261 14.3956C5.06172 14.0026 4.64724 13.4475 4.42698 12.8077C4.20672 12.1678 4.19168 11.4752 4.38395 10.8264C4.57621 10.1776 4.9662 9.60499 5.49951 9.18846L5.5 9.18909Z",
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13C8.19036 13 8.75 12.4404 8.75 11.75C8.75 11.0596 8.19036 10.5 7.5 10.5C6.80964 10.5 6.25 11.0596 6.25 11.75C6.25 12.4404 6.80964 13 7.5 13Z",
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5V5.5",
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.42a414d2.svg";
export { ForwardRef as ReactComponent };